"use client";

import React from "react";
import {
  BannerImage,
  CTAContainer,
  GeminiPromoBannerCard,
  GeminiPromoBannerCardContent,
  TextNodeContainer
} from "./styles";
import { Button, mediaQuery, Text } from "@hubble/web";
import { useMedia } from "react-use";
import { useCountryStateCookies } from "hooks/cookies/useCountryStateCookies";
import NextImage from "components/parts/NextImage";
import { PROD_EXCHANGE_ENDPOINT } from "constants/index";
import { mixpanelClient } from "analytics/mixpanel";
import { Link } from "i18n/routing";

function GeminiPromoBanner({ cryptopedia }: { cryptopedia?: boolean }) {
  const isMobile = useMedia(mediaQuery.mobileXsDown, false);

  const { isUS } = useCountryStateCookies();

  return (
    <GeminiPromoBannerCard customBgColor="#e9e5ff" density="sm">
      <GeminiPromoBannerCardContent>
        <TextNodeContainer flexDirection="column" justifyContent="flex-start">
          <Text.Heading size="xl" color="#6E53FF" marketing>
            {isUS
              ? "Get $20 in bitcoin when you trade $100"
              : "Unlock the future of money on Gemini"}
          </Text.Heading>
          <Text.Body size={isMobile ? "sm" : "lg"} marketing>
            {isUS ? (
              <React.Fragment>
                Sign up in minutes and start your crypto journey on the trusted
                crypto-native finance platform.{" "}
                <Link
                  className="text-[#6E53FF] !underline !underline-offset-6"
                  href="/legal/gemini-new-user-incentive-program-terms"
                  target="_blank"
                >
                  Terms apply.
                </Link>
              </React.Fragment>
            ) : (
              "Start your crypto journey in minutes on the trusted crypto-native finance platform"
            )}
          </Text.Body>
        </TextNodeContainer>
        {!(cryptopedia && !isMobile) && (
          <BannerImage
            src="https://cdn.builder.io/api/v1/image/assets/1b77ce3a269a43e985e77f3d65f715ba/a66e33dee73f4dc1bb4dc2a42084a00e"
            alt="Gemini Promo Card image"
            height={204}
            width={460}
            style={
              isMobile
                ? {
                    maxWidth: "100%",
                    height: "131px",
                    width: "auto"
                  }
                : {
                    alignSelf: "center",
                    maxWidth: "min(460px, 45%)",
                    height: "auto"
                  }
            }
          />
        )}
        <CTAContainer>
          <NextImage
            src="https://cdn.builder.io/api/v1/image/assets/1b77ce3a269a43e985e77f3d65f715ba/68b0cd0b74104a889a538aa680da9a58"
            alt="Gemini Logo"
            height={22}
            width={100}
            style={isMobile ? { height: 17, width: 77 } : {}}
          />
          <Button.Primary
            onClick={() => {
              mixpanelClient.track(
                `Cryptopedia${isMobile ? " Mobile " : " "}Ad banner - ${isUS ? "Claim Offer" : "Get Started"} clicked`
              );
            }}
            size={isMobile ? "md" : "lg"}
            target="_blank"
            href={`${PROD_EXCHANGE_ENDPOINT}/register${isUS ? "?referral=Cryptopedia" : ""}`}
          >
            {isUS ? "Claim offer" : "Get started"}
          </Button.Primary>
        </CTAContainer>
      </GeminiPromoBannerCardContent>
    </GeminiPromoBannerCard>
  );
}
export default GeminiPromoBanner;
